var map = {
	"./en": "5667",
	"./en.js": "5667",
	"./ja": "7f21",
	"./ja.js": "7f21",
	"./zh-CN": "85cf",
	"./zh-CN.js": "85cf"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9e08";
module.exports = webpackAsyncContext;